export function getUserMentionLabel(fullName, email) {
    return fullName || email.split('@', 1)[0] || email;
}
//# sourceMappingURL=getUserMentionLabel.js.map